module.exports = __webpack_public_path__ + "static/media/chart-arrow-back-disabled.b90d193d.svg";